(function () {
  try {
    if (!window.Shopify || !Shopify.shop) return;

    var STORE = Shopify.shop.toLowerCase(); // permanent myshopify domain
    var SHEET_ID = "1ceju30eTYuj4HBEEyxchDM3WVUVTOb7ZuQP7dwM1UE4";
    var SHEET_NAME = "Sheet1";
    var CACHE_KEY = "__theme_lock_" + STORE;

    // already validated
    if (localStorage.getItem(CACHE_KEY) === "ok") return;

    fetch(
      "https://docs.google.com/spreadsheets/d/" +
        SHEET_ID +
        "/gviz/tq?tqx=out:json&sheet=" +
        encodeURIComponent(SHEET_NAME)
    )
      .then(function (r) {
        return r.text();
      })
      .then(function (t) {
        var json = JSON.parse(t.substring(47).slice(0, -2));
        var rows = json.table.rows || [];
        var allowed = false;

        rows.forEach(function (r) {
          var c = r.c || [];
          var domain = String(c[1]?.v || "").toLowerCase().trim();
          var status = String(c[2]?.v || "").toLowerCase().trim();

          if (domain === STORE && status === "active") {
            allowed = true;
          }
        });

        if (allowed) {
          localStorage.setItem(CACHE_KEY, "ok");
        } else {
          lockTheme();
        }
      })
      .catch(lockTheme);

    function lockTheme() {
      if (document.getElementById("__theme_lock")) return;

      var overlay = document.createElement("div");
      overlay.id = "__theme_lock";
      overlay.style =
        "position:fixed;inset:0;z-index:999999;background:#0b0b0b;color:#fff;display:flex;align-items:center;justify-content:center;font-family:system-ui";

      overlay.innerHTML =
        '<div style="max-width:520px;padding:28px;border:1px solid #333;border-radius:12px;text-align:center">' +
        "<h2>Unauthorized Theme Usage</h2>" +
        "<p>This Shopify theme is licensed.</p>" +
        "<p>Store not authorized to use this theme.</p>" +
        "</div>";

      document.body.appendChild(overlay);
    }
  } catch (e) {
    console.error("Theme license error", e);
  }
})();
